import { combineReducers } from "redux";
import buildFetchDuck from "../../vendor/signal-utils/build-fetch-duck";
import apiUrl from "../../api-url";
import { alfBy } from "../../components/selectors";

const STORE_MOUNT_POINT = "domainData";

const EXCEPTION_TYPES_URL = apiUrl("/shipping-ng/exceptions");
const STATUS_TYPES_URL = apiUrl("/shipping-ng/current_statuses");
const SHIPMENT_MODES_URL = apiUrl("/shipping-ng/shipment_modes");
const CARRIERS_URL = apiUrl("/shipping-ng/carriers");
const SHIPMENT_IDS_URL = apiUrl("/shipping-ng/carrier-shipment-ids");
const PARTS_URL = apiUrl("/shipping-ng/parts");

const exceptionTypeDuck = buildFetchDuck("exceptionTypes");
const statusTypeDuck = buildFetchDuck("statusTypes");
const shipmentModeDuck = buildFetchDuck("shipmentModes");
const carrierDuck = buildFetchDuck("carriers");
const shipmentIDDuck = buildFetchDuck("shipmentIDs");
const partDuck = buildFetchDuck("parts");

export function fetchDomainData() {
  return dispatch => {
    dispatch(exceptionTypeDuck.fetch(EXCEPTION_TYPES_URL));
    dispatch(statusTypeDuck.fetch(STATUS_TYPES_URL));
    dispatch(shipmentModeDuck.fetch(SHIPMENT_MODES_URL));
    dispatch(carrierDuck.fetch(CARRIERS_URL));
    dispatch(shipmentIDDuck.fetch(SHIPMENT_IDS_URL));
    dispatch(partDuck.fetch(PARTS_URL));
  };
}

// selectors
const getExceptionTypes = state => {
  return state.domainData.exceptionTypes.data;
};
const selectExceptionTypesAlphabetically = alfBy(getExceptionTypes, "name");
const getStatusTypes = state => {
  return state.domainData.statusTypes.data;
};
const selectStatusTypesAlphabetically = alfBy(getStatusTypes, "name");
const getShipmentModes = state => {
  return state.domainData.shipmentModes.data;
};
const selectShipmentModesAlphabetically = alfBy(getShipmentModes, "name");
const getCarriers = state => {
  return state.domainData.carriers.data;
};
const selectCarriersAlphabetically = alfBy(getCarriers, "name");
const getShipmentIDs = state => {
  return state.domainData.shipmentIDs.data;
};
const getParts = state => {
  return state.domainData.parts.data;
};

export default {
  mountPoint: STORE_MOUNT_POINT,
  actionCreators: {
    fetchDomainData
  },
  selectors: {
    getExceptionTypes,
    selectExceptionTypesAlphabetically,
    getStatusTypes,
    selectStatusTypesAlphabetically,
    getShipmentModes,
    selectShipmentModesAlphabetically,
    getCarriers,
    selectCarriersAlphabetically,
    getShipmentIDs,
    getParts
  },
  reducer: combineReducers({
    exceptionTypes: exceptionTypeDuck.reducer,
    statusTypes: statusTypeDuck.reducer,
    shipmentModes: shipmentModeDuck.reducer,
    carriers: carrierDuck.reducer,
    shipmentIDs: shipmentIDDuck.reducer,
    parts: partDuck.reducer
  })
};



// WEBPACK FOOTER //
// ./src/modules/domain-data/DomainDataState.js